var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnCalendar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3438 14V5.34375H1.65625V14H12.3438ZM12.3438 2C12.6979 2 13 2.13542 13.25 2.40625C13.5208 2.67708 13.6562 2.98958 13.6562 3.34375V14C13.6562 14.3542 13.5208 14.6667 13.25 14.9375C13 15.2083 12.6979 15.3438 12.3438 15.3438H1.65625C1.30208 15.3438 0.989583 15.2083 0.71875 14.9375C0.46875 14.6667 0.34375 14.3542 0.34375 14V3.34375C0.34375 2.98958 0.46875 2.67708 0.71875 2.40625C0.989583 2.13542 1.30208 2 1.65625 2H2.34375V0.65625H3.65625V2H10.3438V0.65625H11.6562V2H12.3438Z",
    fill: "#007BFF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-calendar.497ccc90.svg";
export { ForwardRef as ReactComponent };